import { createCRUDHook } from './createCRUDHook';
import { ProductionStationListItem } from 'utils/models';
import {
  INVOKE_GET_PRODUCTION_STATION_SP,
  PRODUCTION_STATION,
  TLKP_PRODUCTION_STATION,
} from 'hooks';
import { INVOKE_GET_SUB_ITEM_PRODUCTION_STATION_SP } from './apiEndPoints';
interface ProductionStationCustomOperations {
  getProductionStationDataByStationId: (id: number) => Promise<any[]>;
  InvokeGetSubItemProductionStationSP: (id: number) => Promise<any[]>;
}

const { Context, useManager, useConsumer } = createCRUDHook<
  ProductionStationListItem,
  ProductionStationListItem[],
  ProductionStationCustomOperations
>({
  entityName: 'ProductionStation',
  endpoint: PRODUCTION_STATION,

  customOperations: (auth) => ({
    getProductionStationDataByStationId: async (id: number): Promise<any[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TLKP_PRODUCTION_STATION +
            INVOKE_GET_PRODUCTION_STATION_SP +
            `?productionStationId=${id}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },

    InvokeGetSubItemProductionStationSP: async (id: number): Promise<any[]> => {
      try {
        const res = await auth.makeAuthenticatedGet(
          TLKP_PRODUCTION_STATION +
            INVOKE_GET_SUB_ITEM_PRODUCTION_STATION_SP +
            `?orderItemId=${id}`
        );
        return Promise.resolve(res.data);
      } catch (error) {
        return Promise.reject(error);
      }
    },
  }),
});

export const ProductionStationContext = Context;
export const useProductionStationManager = useManager;
export const useProductionStation = useConsumer;
